export default "__VITE_ASSET__u33yblxV__"